import { useCallback } from 'react';
import { useIntl } from 'react-intl';

function getBytesInfo(size: number) {
  let divider: number;
  let unit: string;
  if (size < 1e6) {
    divider = 1e3;
    unit = 'kilobyte';
  } else {
    divider = 1e6;
    unit = 'megabyte';
  }

  return {
    size: Math.floor((size / divider) * 100) / 100,
    unit,
  };
}

export function useFormatBytes() {
  const { formatMessage } = useIntl();

  const formatBytes = useCallback(
    function formatBytes(bytes: number): string {
      const { size, unit } = getBytesInfo(bytes);
      return `${size} ${formatMessage({ id: unit })}`;
    },
    [formatMessage]
  );

  return { formatBytes };
}
